import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DataSource from 'devextreme/data/data_source';
import { lastValueFrom } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { ConfigService } from 'src/app/share/services/config.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { StorageService } from 'src/app/share/services/storage.service';
import { UrlService } from 'src/app/share/services/url.service';

@Component({
  selector: 'app-start-extern',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  standalone: false,
})
export class StartExternComponent implements OnDestroy {
  window = window;

  addressLat: number;
  addressLon: number;

  formData: any = {
    searchBetreuungsArt: null,
    searchBetreuungsZeit: null,
    meinStandort: '',
    meinStandortLat: null,
    meinStandortLon: null,
  };

  betreuungsZeitDataSource: any = undefined;

  welcomeText: SafeHtml;
  isSearchBarOn: number = 1;

  selectedLanguageObservable: Subscription;

  constructor(
    private urlService: UrlService,
    public configService: ConfigService,
    private apiService: ApiService,
    private storageService: StorageService,
    private languageService: LanguageService,
    private sanitizer: DomSanitizer
  ) {
    this.onBetreuungsArtValueChanged = this.onBetreuungsArtValueChanged.bind(this);
    this.onBetreuungsZeitValueChanged = this.onBetreuungsZeitValueChanged.bind(this);

    this.setInitialCurrentPos();

    this.isSearchBarOn = configService.getGlobalSettingAsNumber('isSearchBarOn');

    this.selectedLanguageObservable = languageService.get_selectedLanguageObservable.subscribe((lang) => {
      lastValueFrom(this.apiService.post<any>(RouteKeys.Extern.get_global_settings, { key: 'welcomeText' + lang.toUpperCase() }))
        .then((response) => {
          if (response.wert != null && response.wert != undefined) {
            this.welcomeText = this.sanitizer.bypassSecurityTrustHtml(response.wert);
          }
        })
        .catch((err) => {
          throw err.error ? err.error.message : err.message;
        });
    });
  }

  ngOnInit(): void {
    let ids = this.storageService.getFromLocale('selectedIds');
    if (ids != null && ids != undefined && ids != '') {
      this.urlService.refreshQueryParams({
        i: ids,
      });
    }
  }

  ngOnDestroy(): void {
    if (this.selectedLanguageObservable) {
      this.selectedLanguageObservable.unsubscribe();
    }
  }

  onSearchClick() {
    if (this.formData.searchBetreuungsArt) {
      this.storageService.saveToLocale('searchBetreuungsArt', this.formData.searchBetreuungsArt);
    }
    if (this.formData.searchBetreuungsZeit) {
      this.storageService.saveToLocale('searchBetreuungsZeit', this.formData.searchBetreuungsZeit);
    }

    const token = btoa(encodeURIComponent(JSON.stringify(this.formData)));
    this.urlService.naviToPreserveQueryParams('extern/search', { s: token });
  }

  onBetreuungsArtValueChanged(e) {
    this.betreuungsZeitDataSource = this.configService.getKatalog('BetreuungsZeitKatalog').filter((x) => x.beziehungen.includes(e.value));
    if (!this.betreuungsZeitDataSource.find((x) => x.id === this.formData.searchBetreuungsZeit)) {
      this.formData.searchBetreuungsZeit = undefined;
    }

    const token = btoa(encodeURIComponent(JSON.stringify(this.formData)));
    this.urlService.refreshQueryParams({
      s: token,
    });
  }

  onBetreuungsZeitValueChanged(e) {
    const token = btoa(encodeURIComponent(JSON.stringify(this.formData)));
    this.urlService.refreshQueryParams({
      s: token,
    });
  }

  setInitialCurrentPos() {
    const pos: any = this.storageService.getFromLocale('position');
    if (pos === null) {
      this.addressLat = this.configService.getGlobalSettingAsNumber('defaultLatitude');
      this.addressLon = this.configService.getGlobalSettingAsNumber('defaultLongitude');
    } else {
      this.addressLat = pos.lat;
      this.addressLon = pos.lon;
    }
  }

  onSelected(e) {
    if (e && e.display_name) {
      this.formData.meinStandort = e.display_name;
      this.formData.meinStandortLat = e.lat;
      this.formData.meinStandortLon = e.lon;

      const token = btoa(encodeURIComponent(JSON.stringify(this.formData)));

      this.urlService.refreshQueryParams({
        s: token,
      });
    }
  }
}
